import { selectPayoutDisability } from 'selectors/dashboard';
import { fetchDisability } from 'actions/digital-advice';
import { createPage } from './Payouts';

export default createPage({
  getPayoutsAction: fetchDisability,
  selectPayouts: selectPayoutDisability,
  payoutType: 'disability',
});
